export default __webpack_public_path__ + "static/media/placeholder.12a4b9ef.png";